import React, { useState } from "react";
import { Button, Modal, Transfer } from "antd";
import "./index.css";

const AllCols = [
  "标题",
  "所属分类",
  "用户分层",
  "车型解析",
  "内容场景",
  "内容",
  "星级",
  "是否允许下载",
  "投放渠道",
  "投放量",
  "转发量",
  "点击量",
  "点赞量",
  "评论数量",
  "收藏量",
  "线索收集数量",
  "创建时间",
  "作者",
];

const mockData = AllCols.map((title, i) => ({
  key: title,
  title: title,
  description: `description of content${i + 1}`,
}));

const SettingBtn = (props) => {
  const [visible, setVisible] = useState(false);
  const [targetKeys, setTargetKeys] = useState(props.defaultTargetKeys);
  const [selectedKeys, setSelectedKeys] = useState([]);

  //   useEffect(() => {
  //     setTargetKeys(defaultTargetKeys);
  //   }, [defaultTargetKeys]);

  const onChange = (nextTargetKeys, direction, moveKeys) => {
    console.log("targetKeys:", nextTargetKeys);
    console.log("direction:", direction);
    console.log("moveKeys:", moveKeys);
    setTargetKeys(nextTargetKeys);
  };
  const onSelectChange = (sourceSelectedKeys, targetSelectedKeys) => {
    console.log("sourceSelectedKeys:", sourceSelectedKeys);
    console.log("targetSelectedKeys:", targetSelectedKeys);
    setSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys]);
  };
  const onScroll = (direction, e) => {
    console.log("direction:", direction);
    console.log("target:", e.target);
  };
  return (
    <>
      <Button
        color="purple"
        variant="solid"
        onClick={() => setVisible(true)}
        style={{ marginRight: 16 }}
      >
        自定义字段
      </Button>
      <Modal
        width={550}
        open={visible}
        onOk={() => {
          props.onChange(targetKeys);
          setVisible(false);
        }}
        onCancel={() => {
          setVisible(false);
        }}
      >
        <Transfer
          className="authTransfer"
          dataSource={mockData}
          titles={["所有字段", "需要展示的字段"]}
          targetKeys={targetKeys}
          selectedKeys={selectedKeys}
          onChange={onChange}
          onSelectChange={onSelectChange}
          onScroll={onScroll}
          render={(item) => item.title}
        />
      </Modal>
    </>
  );
};

export default SettingBtn;
